// src/components/extraction/RechnungTabelle.jsx
// Tabellarische Übersicht aller erfassten Rechnungen. Klick auf eine Zeile öffnet sie zur
// Bearbeitung (siehe Extraction.jsx: zeileBearbeiten) - die Positionen sieht man dort im
// Formular (RechnungFieldsView -> PositionenView), nicht mehr direkt in der Tabelle. Spalten
// für MwSt-Sätze werden dynamisch aus mwstSpalten.js erzeugt.
//
// Das eigentliche Ansichtsmodell (Status, Positionencheck, Kommentar, Zellmarkierung) kommt aus
// rechnungAnsicht.js - dieselbe Funktion nutzt später auch der Excel-Export (Schritt 9), damit
// beide Darstellungen garantiert übereinstimmen.
import React from 'react'
import getMwstSpalten from './mwstSpalten'
import { baueZeilenAnsicht } from './rechnungAnsicht'
import { useDialog } from '../../components/shared/Dialog'

function RechnungTabelle ({
  eintraege,
  bearbeitungsId,
  onZeileBearbeiten,
  onZeileLoeschen
}) {
  const { confirm } = useDialog()
  const mwstSpalten = getMwstSpalten()

  const loeschen = async (id, e) => {
    e.stopPropagation()
    const bestaetigt = await confirm({
      titel: 'Eintrag löschen',
      nachricht: 'Diesen Eintrag wirklich löschen?',
      bestaetigenLabel: 'Löschen',
      gefahr: true
    })
    if (bestaetigt) {
      onZeileLoeschen(id)
    }
  }

  if (eintraege.length === 0) {
    return <p className='placeholder-tab'>Noch keine Rechnungen erfasst.</p>
  }

  return (
    <div className='rechnung-tabelle-container'>
      <table className='rechnung-tabelle'>
        <thead>
          <tr>
            <th>Lieferant</th>
            <th>Lieferant-Adresse</th>
            <th>Rg.-Nummer</th>
            <th>Rg.-Datum</th>
            <th>Brutto</th>
            <th>Netto</th>
            {mwstSpalten.map(({ key, label }) => (
              <th key={key}>{label}</th>
            ))}
            <th>Skonto</th>
            <th>Status</th>
            <th>Pos.</th>
            <th>Kommentar</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {eintraege.map(eintrag => {
            const ansicht = baueZeilenAnsicht(eintrag)
            const istAktiv = eintrag.id === bearbeitungsId

            return (
              <tr
                key={eintrag.id}
                className={
                  [
                    istAktiv ? 'zeile-aktiv' : null,
                    ansicht.ibanAuswahlOffen ? 'zeile-iban-warnung' : null
                  ]
                    .filter(Boolean)
                    .join(' ') || undefined
                }
                title={
                  ansicht.ibanAuswahlOffen
                    ? 'Es liegen mehrere Bankverbindungen vor - bitte im Formular die richtige IBAN auswählen.'
                    : undefined
                }
                onClick={() => onZeileBearbeiten(eintrag.id)}
              >
                <td
                  className={ansicht.lieferant.klasse}
                  title={ansicht.lieferant.titel}
                >
                  {ansicht.lieferant.wert}
                </td>
                <td
                  className={ansicht.lieferantAdresse.klasse}
                  title={ansicht.lieferantAdresse.titel}
                >
                  {ansicht.lieferantAdresse.wert}
                </td>
                <td
                  className={ansicht.rechnungsnummer.klasse}
                  title={ansicht.rechnungsnummer.titel}
                >
                  {ansicht.rechnungsnummer.wert}
                </td>
                <td
                  className={ansicht.rechnungsdatum.klasse}
                  title={ansicht.rechnungsdatum.titel}
                >
                  {ansicht.rechnungsdatum.wertFormatiert}
                </td>
                <td
                  className={ansicht.brutto.klasse}
                  title={ansicht.brutto.titel}
                >
                  {ansicht.brutto.wertFormatiert}
                </td>
                <td
                  className={ansicht.netto.klasse}
                  title={ansicht.netto.titel}
                >
                  {ansicht.netto.wertFormatiert}
                </td>
                {ansicht.mwst.map(spalte => (
                  <td
                    key={spalte.satz}
                    className={spalte.klasse}
                    title={spalte.titel}
                  >
                    {spalte.wertFormatiert}
                  </td>
                ))}
                <td
                  className={ansicht.skonto.klasse}
                  title={ansicht.skonto.titel}
                >
                  {ansicht.skonto.wertFormatiert}
                </td>
                <td>
                  <span className={`status-badge ${ansicht.status.klasse}`}>
                    {ansicht.status.text}
                  </span>
                </td>
                <td>
                  <span
                    className={ansicht.positionencheck.klasse}
                    title={ansicht.positionencheck.titel}
                  >
                    {ansicht.positionencheck.text}
                  </span>
                </td>
                <td className='kommentar-zelle' title={ansicht.kommentar}>
                  {ansicht.kommentar}
                </td>
                <td>
                  <button
                    type='button'
                    className='btn-icon'
                    onClick={e => loeschen(eintrag.id, e)}
                    title='Eintrag löschen'
                  >
                    🗑
                  </button>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default RechnungTabelle
